import type { components } from "../api/schema";
import { parseCellParam } from "./alignmentDrill";
import type { AlignmentCellParam } from "./routerSearch";
import { parseAlignmentSearch } from "./routerSearch";
import type { ListQueryFilters } from "./useListQuery";

type Answer = components["schemas"]["AnswerResponse"];

// ASSUMED(Call buckets retain the first answer in server order per
// transcript; historical Marks and Labels never create extra call rows.)
export function reviewCalls<T extends Pick<Answer, "transcript_id">>(
  items: T[],
): T[] {
  const seen = new Set<string>();
  return items.filter((item) => {
    if (seen.has(item.transcript_id)) return false;
    seen.add(item.transcript_id);
    return true;
  });
}

export function reviewCell(feed: string) {
  return parseAlignmentSearch(Object.fromEntries(new URLSearchParams(feed)))
    .cell;
}

export function markerScoreRequest(
  filters: ListQueryFilters<"/v1/answers">,
  cell?: AlignmentCellParam,
) {
  const selected = parseCellParam(cell);
  return {
    cell: selected
      ? { human_verdict: selected.human, machine_verdict: selected.machine }
      : null,
    marker_id: filters.marker_id ?? null,
    filters: {
      marker_id: filters.marker_id ?? null,
      agent_id: filters.agent_id ?? null,
      team_id: filters.team_id ?? null,
      agent_version_id: filters.agent_version_id ?? null,
      batch_id: filters.batch_id ?? null,
      source: filters.origin ?? null,
    },
    time_range:
      filters.created_after && filters.created_before
        ? { start: filters.created_after, end: filters.created_before }
        : null,
    human_side: "latest" as const,
    include_disagreements: true,
    include_rater_agreement: false,
    disagreement_limit: 50,
    rater_disagreement_limit: 50,
    page_size: 50,
  };
}
